import { EDITOR_COPY } from './copy';
import type { AiTool } from './setups';

/**
 * Which of the page's tools a reported name is (spec 245), or `null` for one
 * it does not know.
 *
 * The name is the tool's own claim, sent when it connects (MCP `clientInfo`),
 * and no tool documents it, so the match is loose: a part of the name, any
 * case. It labels a row for a person and decides nothing. Copilot is matched
 * by VS Code's name too, since that is where Copilot Chat connects from.
 */
export function knownTool(clientName: string): Exclude<AiTool, 'other'> | null {
  const name = clientName.toLowerCase();
  if (/claude[\s-]?code/.test(name)) return 'claude-code';
  if (/claude[\s.-]?ai|anthropic/.test(name)) return 'claude-ai';
  if (/codex/.test(name)) return 'codex';
  if (/copilot|visual studio code|vs ?code/.test(name)) return 'copilot';
  return null;
}

/** A reported name as a person reads it: the tool's own name where known. */
export function toolLabel(clientName: string): string {
  const tool = knownTool(clientName);
  return tool === null ? clientName : EDITOR_COPY.tabs[tool];
}
